import { Injectable } from '@angular/core';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { map } from 'rxjs/internal/operators/map';
import { ActiveUserConstants } from '../activeusers_api/constatnts/activeusers.constant';

@Injectable({
  providedIn: 'root'
})
export class ActiveusersService {
  userId = sessionStorage.getItem('userId');
  loginUserRole = sessionStorage.getItem('userRole');
  retailUserId = sessionStorage.getItem('retailerId');
  storeUserId = sessionStorage.getItem('storeID');
  COMMON_URL = ActiveUserConstants.SLASH_USER_MANAGEMENT + ActiveUserConstants.USER_MANAGEMENT + ActiveUserConstants.SLASH_USER;
  CONVERT_USER = this.COMMON_URL + ActiveUserConstants.SLASH_CONVERT_USER;
  RETAIL_STORE_COMMON_URL = ActiveUserConstants.AND_STATUS + ActiveUserConstants.EQUALS + ActiveUserConstants.ACTIVE;
  ACTIVE_USERS_URL = `${this.COMMON_URL}${ActiveUserConstants.STATUS_ACTIVE}${ActiveUserConstants.EQUALS}${ActiveUserConstants.ACTIVE}${ActiveUserConstants.PAGE_NUMBER}${ActiveUserConstants.EQUALS}`;
  RETAILHQ_USER_URL = `${this.COMMON_URL}${ActiveUserConstants.SLASH}${this.userId}${ActiveUserConstants.SLASH_RETAIL
    }${ActiveUserConstants.RETAILERID}${ActiveUserConstants.EQUALS}${this.retailUserId
    }${this.RETAIL_STORE_COMMON_URL}${ActiveUserConstants.PAGE_NUMBER}${ActiveUserConstants.EQUALS}`;

  REGIONAL_URL = `${this.COMMON_URL}${ActiveUserConstants.SLASH}${this.userId}${ActiveUserConstants.SLASH_RETAIL
    }${ActiveUserConstants.RETAILERID}${ActiveUserConstants.EQUALS}`;

  STORES_URL = `${this.COMMON_URL}${ActiveUserConstants.SLASH}${this.userId}${ActiveUserConstants.SLASH_RETAIL
    }${ActiveUserConstants.SLASH}${this.retailUserId}${ActiveUserConstants.STORE}${ActiveUserConstants.STOREID}${ActiveUserConstants.EQUALS}${this.storeUserId
    }${this.RETAIL_STORE_COMMON_URL}${ActiveUserConstants.PAGE_NUMBER}${ActiveUserConstants.EQUALS}`;
  DOWNLOAD_URL = ActiveUserConstants.SLASH + ActiveUserConstants.DOWNLOAD + ActiveUserConstants.STATUS_ACTIVE + ActiveUserConstants.EQUALS + ActiveUserConstants.ACTIVE + ActiveUserConstants.AND;
  RETAILHQ_DOWNLOOAD_URL = ActiveUserConstants.SLASH + ActiveUserConstants.DOWNLOAD + ActiveUserConstants.RETAILER_ID + ActiveUserConstants.EQUALS + this.retailUserId;
  constructor(private httpMethod: HttpMethodsService) { }

  getAllActiveUsers(pageNumber: number, filterString?: string, retailerId?: string) {
    let url; 
    //IIT3-1119
    if(this.loginUserRole === ActiveUserConstants.RETAIL_USER_ROLE){
      url = pageNumber ? `${this.RETAILHQ_USER_URL}${pageNumber}` : `${this.COMMON_URL}${ActiveUserConstants.SLASH}${this.userId}${ActiveUserConstants.SLASH_RETAIL}${ActiveUserConstants.RETAILERID}${ActiveUserConstants.EQUALS}${this.retailUserId}${this.RETAIL_STORE_COMMON_URL}`;
    }else if(this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE){
      url = pageNumber ? `${this.REGIONAL_URL}${retailerId}${this.RETAIL_STORE_COMMON_URL}${ActiveUserConstants.PAGE_NUMBER}${ActiveUserConstants.EQUALS}${pageNumber}` : `${this.REGIONAL_URL}${retailerId}${this.RETAIL_STORE_COMMON_URL}`; 
    }else if(this.loginUserRole === ActiveUserConstants.STORE_ROLE){
      url = `${this.STORES_URL}${pageNumber}`;
    }else{
      url = pageNumber ? `${this.ACTIVE_USERS_URL}${pageNumber}`: `${this.COMMON_URL}${ActiveUserConstants.STATUS_ACTIVE}${ActiveUserConstants.EQUALS}${ActiveUserConstants.ACTIVE}` ;
    }
    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }
  // Currently Working TODO
  deleteUser(tempuid) {
    return this.httpMethod.deleteUser(this.COMMON_URL, tempuid);
  }

  postAllUsersForCsv(params) {
    return this.httpMethod.postcsv(this.COMMON_URL + ActiveUserConstants.SLASH + ActiveUserConstants.DOWNLOAD + ActiveUserConstants.STATUS_ACTIVE + ActiveUserConstants.EQUALS +
      ActiveUserConstants.ACTIVE, params)
      .pipe(map((res: any) =>
        res));
  }
  postdownloadcsvUsersbyFilter(filterString: string, params) {
    return this.httpMethod.postfiltercsv(`${this.COMMON_URL}${this.DOWNLOAD_URL}${filterString}`, params)
      .pipe(map((res: any) =>
        (res))
      );
  }

  postdownloadcsvUsersbyFilterRetailHq(filterString: string, params) {
    return this.httpMethod.postfiltercsv(`${this.COMMON_URL}${this.RETAILHQ_DOWNLOOAD_URL}${filterString}`, params)
      .pipe(map((res: any) =>
        (res))
      );
  }

  postAllUsersRetailHqForCsv(params) {
    return this.httpMethod.postcsv(this.COMMON_URL + ActiveUserConstants.SLASH + ActiveUserConstants.DOWNLOAD +
      ActiveUserConstants.RETAILER_ID + ActiveUserConstants.EQUALS + this.retailUserId
      , params)
      .pipe(map((res: any) =>
        res));
  }

  getAllUsersData() {
    return this.httpMethod.get(`${this.COMMON_URL}`)
      .pipe(map((res: any) =>
        (res))
      );
  }

  /**
   * Transfer existing user account to some other user.
   * @param userData Updated data for the new user assignment
   * @returns Response of the update operation from API
   */
  transferUser(userData) {
    let params = { action: ActiveUserConstants.ACTION_TRANSFER };
    return this.httpMethod.patch(this.CONVERT_USER, userData, false, params).pipe(map((res: any) => (res)));
  }
}
